import React, {Component} from 'react';
import {
  withRouter, Route ,Link
} from 'react-router-dom';
import {connect} from 'react-redux';

// CSS
import style from '../../Styles/Components/Header.module.css';
import { CloudfrontImage } from "../CloudfrontAsset";

class HeaderView extends Component {
  constructor() {
    super();
  }

  render() {
    return (
      <div className={style.headerContainer}>
        {this.props.onBackPress && <CloudfrontImage
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-back.svg"} className={style.icon} style={{left: 16}}
          logContext={{ component: 'Header', assetType: 'back' }}
          onClick={this.props.onBackPress.bind(this)} />
        }
        <span className={style.headerContent}>{this.props.content}</span>
        {this.props.onClosePress && <CloudfrontImage
          src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-delete.svg"} className={style.icon} style={{right: 16}}
          logContext={{ component: 'Header', assetType: 'close' }}
          onClick={this.props.onClosePress && this.props.onClosePress.bind(this)} />
        }
      </div>
    );
  }
}

export default connect((state) => {
  return { };
})(withRouter(HeaderView));

